import { initializationSagas, mapDictFilters, mapDictNodes, tryGetEnvironmentPart } from './state/sagas';
import { state } from './state';
import {
    FactorinInitializer, InitializationErrorPages,
    ForbiddenError, UserNotFoundError,
} from './InitializationMiddleware';
import translations from './translations.json';


export * from './state/actions';
export * from './state/utils';
export { mapDictFilters, tryGetEnvironmentPart, mapDictNodes };

export * from './components';
export * from './utils';

export const environment = {
    environment: {
        changeLanguageSagas: [],
        initializationSagas,
        initializationErrors: {
            ForbiddenError,
            UserNotFoundError,
        },
    },

    state,

    translations,

    renderChain: [
        [FactorinInitializer, 0],
        [InitializationErrorPages, 30],
    ],
};
